import * as React from 'react';

import { NavigationRegion } from 'components/layout/pages/navigation-region';
import { SharedUiNavigationBarWrapper } from 'components/infosite/shared-ui/details/navigation-bar-wrapper';

export const PropertyNavigation: React.FC<{}> = () => (
  <NavigationRegion className="navigation-bar-region constrained">
    <SharedUiNavigationBarWrapper showReserveBtn={true} showNightlyPrice={true} />
  </NavigationRegion>
);
